/**
 * package: com.inq.flash.messagingframework
 * class: StringUtils
 * root Object
 */
com.inq.flash.messagingframework.StringUtils =  {};
/** @private @type {Array} */
com.inq.flash.messagingframework.StringUtils.__name__ = ["com","inq","flash","messagingframework","StringUtils"];

/**
 * htmlEncode
 *
 * $type TFun([{ name => text, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * public static function htmlEncode(text:String):String
 * @public
 * @static
 * @param {string}  text
 * @return {string}
 */
com.inq.flash.messagingframework.StringUtils.htmlEncode = function(text) {
    if(text == null || text.length == 0) return text;
    return text.split("&").join("&amp;").split("<").join("&lt;").split(">").join("&gt;").split('"').join("&quot;");
};

/**
 * htmlDecode
 *
 * $type TFun([{ name => text, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * public static function htmlDecode(text:String):String
 * @public
 * @static
 * @param {string}  text
 * @return {string}
 */
com.inq.flash.messagingframework.StringUtils.htmlDecode = function(text) {
	if(text == null || text.length == 0) return text;
	return text.split("&eq;").join("=").split("&lt;").join("<").split("&gt;").join(">").split("&amp;").join("&").split("&quot;").join("\"").split("&nl;").join("<br/>");
};

/**
 * parseQueryString
 *
 * $type TFun([{ name => str, t => TInst(String,[]), opt => false }],TInst(com.inq.utils.Dictionary,[]))
 * public static function parseQueryString(str:String):Dictionary
 * @public
 * @static
 * @param {string}  str
 * @return {com.inq.utils.Dictionary}
 */
com.inq.flash.messagingframework.StringUtils.parseQueryString = function(str) {
	/** @type {com.inq.utils.Dictionary} */
	var _params = new com.inq.utils.Dictionary();
	try {
		if(str != null && str != "") {

			/** @type {Array} */
			var params = str.split("&");
			/** @type {number} */
			var length = params.length;
			var /** @type {number} */ i = 0;
			/** @type {number} */
			var index = -1;
			while(i < length) {
				/** @type {string} */
				var kvPair = params[i];
				i++;
				if((index = kvPair.indexOf("=")) > 0) {
					/** @type {string} */
					var key = HxOverrides.substr(kvPair,0,index);
					/** @type {string} */
					var value = HxOverrides.substr(kvPair,index + 1,null);
					_params[key] = value;
				}
			}
		}
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
		} else throw(e);
	}
	return _params;
};


/**
 * Checks value and returns true if value is truthful, if it isn't then returns false.
 *
 * @public
 * @static
 * @param {*} value
 * @return {boolean}
 */
com.inq.flash.messagingframework.StringUtils.getBooleanValue = function (value) {
	/** @type {boolean} */
	var returnValue = false;
	/** @type {string} */
	var tempValue = "";
	if(value != null) try {
		tempValue = StringTools.trim(Std.string(value)).toLowerCase();
		
		if(tempValue == "true" || tempValue == "false") {
			if(tempValue == "true") returnValue = true;
		} else {
			/** @type {number} */
			var tempValueInt = Std.parseInt(tempValue);
			if(tempValueInt != 0) returnValue = true;
		}
	} catch( e ) {
		returnValue = false;
	}
	return returnValue;
};
